import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { MenuIcon } from 'lucide-react';
import { Button } from './Button';
import { MobileNav } from './MobileNav';
import { NAV_LINKS, LOGO_DARK } from '../data/site';
interface HeaderProps {
  onDownload: () => void;
}
export function Header({
  onDownload
}: HeaderProps) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`sticky top-0 z-40 w-full bg-cream/90 backdrop-blur transition-shadow duration-300 ${scrolled ? 'shadow-[0_1px_0_rgba(61,57,53,0.08),0_8px_24px_-18px_rgba(61,57,53,0.4)]' : 'shadow-none'}`} data-id="element-94">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3.5 lg:px-8" data-id="element-95">
        <Link to="/" className="flex items-center" aria-label="Mine Geology Systems — home" data-id="element-96">
          <img src={LOGO_DARK} alt="Mine Geology Systems" className="h-8 w-auto" data-id="element-97" />
        </Link>

        <nav aria-label="Primary" className="hidden items-center gap-8 lg:flex" data-id="element-98">
          {NAV_LINKS.map(link => <NavLink key={link.href} to={link.href} className={({
          isActive
        }) => `text-sm font-medium transition-colors ${isActive ? 'font-bold text-charcoal underline decoration-yellow decoration-2 underline-offset-8' : 'text-charcoal/75 hover:text-charcoal'}`} data-id="element-99">
              {link.label}
            </NavLink>)}
        </nav>

        <div className="hidden lg:block" data-id="element-100">
          <Button variant="primary" onClick={onDownload} data-id="element-101">
            Download Free Guide
          </Button>
        </div>

        <div className="flex items-center gap-2 lg:hidden" data-id="element-102">
          <Button variant="primary" onClick={onDownload} className="px-3.5 py-2 text-xs" data-id="element-103">
            Free Guide
          </Button>
          <button type="button" onClick={() => setMenuOpen(true)} aria-label="Open menu" className="inline-flex h-10 w-10 items-center justify-center rounded-md border border-charcoal/15 text-charcoal hover:bg-charcoal/5" data-id="element-104">
            <MenuIcon className="h-5 w-5" data-id="element-105" />
          </button>
        </div>
      </div>

      <MobileNav open={menuOpen} onClose={() => setMenuOpen(false)} onDownload={() => {
      setMenuOpen(false);
      onDownload();
    }} data-id="element-106" />
    </header>;
}